import type { SocialNetwork } from "schemas";

export const SocialLogos: Record<SocialNetwork, Record<"Dark" | "Light", string>> = {
  Amazon: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/535e4cb5-2b98-4043-0a06-60c7e5994d00/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/e18fc7f0-bf49-4d6d-151e-3a5aef3c6e00/feed",
  },
  Bandcamp: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/ae46f960-ed61-4f22-c9a4-fa58ecf3e600/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/9414282f-308f-4c76-3f77-fe210f53d800/feed",
  },
  Behance: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/b274f0ce-7f6e-4eab-4a87-c64f566a8700/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/a67794cd-0232-4db3-3fb9-47a80937a100/feed",
  },
  DeviantArt: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/88543900-cd8c-4029-29be-83d21cdd9100/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/dbf1feef-1624-477e-1b06-9178e4a70200/feed",
  },
  Discord: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/206f6de9-32be-499e-d38f-fb829d77e400/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/2cb54587-29b9-4683-294c-4142d9025a00/feed",
  },
  Dribbble: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/0f91d11c-58f6-4462-5df9-215aa46b1c00/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/f9fc45cf-2e97-48a2-261f-6fd13f735a00/feed",
  },
  Facebook: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/b30fdd28-ce93-4d82-3f62-a1306f23fb00/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/2ae364f6-408a-4ed1-f1f4-8213fede7e00/feed",
  },
  Figma: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/e2fc043d-2e33-41df-451a-80237d76b500/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/32591a06-af92-44ef-c5c8-470c127dd200/feed",
  },
  Github: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/8c9eed81-ffea-495f-b59e-68ceb2fc4900/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/1a8aa999-038b-4ba3-d963-0dc5fcb0f400/feed",
  },
  Google: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/c92961a3-f74d-4292-c24a-178098a18a00/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/caf73a46-8b91-4ee5-6e0c-c2a326905100/feed",
  },
  Instagram: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/5aa5d0ce-c1aa-48c8-202f-dfe02f6e4500/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/fef70368-325c-4d04-1ddf-0d57966ec200/feed",
  },
  Line: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/d8c916a4-2822-4908-d896-1593470b1800/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/4c6eb90d-29da-4622-3aa3-529e280d6f00/feed",
  },
  Linkedin: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/0fb55e1f-1c02-4546-4c20-3aaf09333d00/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/175dd49a-2b01-4984-ac5f-f930f2207c00/feed",
  },
  Medium: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/b8081b7c-395f-40cc-a4b3-961c860df900/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/c6e2aa94-a0dd-450e-dc23-4665eaa41a00/feed",
  },
  Messenger: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/42717a3a-ffb3-4bde-2de7-be44bb3a3f00/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/fd3342a9-8845-4149-44c3-fb48f6bcae00/feed",
  },
  MySpace: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/7aaab3c0-285d-426c-b67a-88af62b3e200/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/0de211dc-879d-4a11-0641-58dc5cc77a00/feed",
  },
  Pinterest: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/da816314-6d96-4840-b8d8-b378689bba00/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/c8461c47-8abf-4843-1fd5-a81d172ec000/feed",
  },
  QQ: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/768ee245-a633-484c-2eda-fa4d6fabdd00/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/ec46b386-fcb2-4e06-990f-50ddfb075400/feed",
  },
  Reddit: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/d7f5cb52-a28f-45d4-cd91-59d91fcc5200/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/f44814f3-2564-44b4-c02a-105005c83000/feed",
  },
  Signal: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/2d2898be-7412-46c6-db7e-4603e7020400/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/ab7677b5-40e0-468a-2687-ef4bb64dd500/feed",
  },
  Skype: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/3adfb698-dd85-495c-3115-d9108ee6b900/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/ddfa4540-0d01-4d80-a3a5-b6704dfaf900/feed",
  },
  Slack: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/320df7e2-360c-4423-1fd7-495ecfc98d00/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/18dff219-4361-4274-a9a3-ff4109f5e200/feed",
  },
  Snapchat: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/fd3982ee-003a-4b1a-c9d8-ba9a9b1f9b00/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/bd631f60-c29b-451e-7c29-948827932900/feed",
  },
  Spotify: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/3d16d65f-c5d1-4478-f688-56674d331500/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/6c6ee63a-8828-457a-cdfc-d7ef581f8b00/feed",
  },
  Teams: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/aa40d9dd-ab8e-49ef-ca6d-f62319d7bd00/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/d16448bc-3167-4c37-7360-b5d535c93a00/feed",
  },
  Telegram: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/24b2958e-f831-4edd-8e1b-1ecbe0e64000/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/c8441499-e7b1-4617-1af7-b3f29ff7e100/feed",
  },
  Threads: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/fcf96db9-c161-48c9-0d87-a56330ee8800/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/5180d7c6-8d10-4a9a-dce9-597d05ee1700/feed",
  },
  Tumblr: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/80d206fc-b513-41b4-f3ec-144485876a00/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/7a9627ab-1dcf-4e51-5572-b56fa9a9ba00/feed",
  },
  Tiktok: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/42770c9c-be3a-4f14-133d-c3538efd2c00/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/a9b0810d-31bb-4ac9-e20c-8a722c61d900/feed",
  },
  Tinder: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/427fddfb-68f3-42b8-e8c4-990a17f28700/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/67791895-e72c-4925-4542-6d62ec3cdb00/feed",
  },
  Twitch: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/d4d49ab2-a8a6-45ad-247b-1e9e830ab100/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/c14d0282-988e-4e00-5c5b-ee86b4d0c000/feed",
  },
  Twitter: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/6c5e0259-830d-4daf-7353-6cb92828ad00/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/cdf56a94-9d0d-43ee-1774-91a00decd700/feed",
  },
  Viber: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/ee73cfff-7e59-4140-218a-1c4764dab500/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/0f10f8be-a5dc-4add-dcd0-8725c160f800/feed",
  },
  Vimeo: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/3a1d748d-595b-47cb-ae91-dc6d4ac86500/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/f3191886-e188-4764-04ed-0536a0c04500/feed",
  },
  VK: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/d763e523-45ba-4707-1493-b84c2dae6b00/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/9433eab8-3192-4e9b-cde9-90e0e321b000/feed",
  },
  WeChat: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/4e582d80-bec7-4033-3367-3a0edb988100/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/aa7dfc60-f070-4e9e-5e44-121ac169ad00/feed",
  },
  Whatsapp: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/af44cde1-f0e4-42c4-3002-99fa45fd3d00/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/ec89715b-0604-44c1-84db-deabb7d48e00/feed",
  },
  Youtube: {
    Dark: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/320cb040-6a5c-4be8-b7e6-c09a0e2b3f00/feed",
    Light: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/c50e9313-ccb4-49fa-757d-d5fbd17f9700/feed",
  },
};
